import api from "@/config/apiConfig"

class TagsController {
  async index() {
    try {
      const response = await api.get("/tags");
      return response.data;
    } catch (error) {
      console.error("Erro no TagsController.index: ", error);
      throw error;
    }
  }

  async create(req) {
    try {
      const response = await api.post("/tags", req);
      return response.data;
    } catch (error) {
      console.error("Erro no TagsController.create: ", error);
      throw error;
    }
  }

  async update(id, req) {
    try {
      const response = await api.patch(`/tags/${id}`, req);
      return response.data;
    } catch (error) {
      console.error("Erro no TagsController.update: ", error);
      throw error;
    }
  }

  async remove(id) {
    try {
      const response = await api.delete(`/tags/${id}`);
      return response.data;
    } catch (error) {
      console.error("Erro no TagsController.remove: ", error);
      throw error;
    }
  }
}

export default new TagsController();
